import { api } from 'shared/api';


const _api = api.injectEndpoints({
  endpoints: (build) => ({
    addNotificationToken: build.mutation<unknown, string>({
      query: (token) => ({
        url: '/notification/addToken',
        method: 'POST',
        params: {
          token,
          primary: true,
        },
      }),
    }),
  }),
});

export const { useAddNotificationTokenMutation } = _api;
